import { store } from "../store/index";
import {
  filterStock,
  listStocks,
  listStockToExport,
  listAll,
  createStockAddInventory,
} from "../store/actions/StockActions";

/**
 * List stock
 */
export const listFilterStock = async (filter) => {
  const result = await store.dispatch(filterStock(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List export data
 */
export const listToExport = async (filter) => {
  const result = await store.dispatch(listStockToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const listStock = async (filter) => {
  const result = await store.dispatch(listStocks(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const listAllStocks = async (uuid) => {
  const result = await store.dispatch(listAll(uuid));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const toCreateStockAddInventory = async (values) => {
  const result = await store.dispatch(createStockAddInventory(values));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
